[
  {
    "id": "al-001",
    "occurredAt": "{{daysAgo:0:5}}",
    "tenantId": "tenant-alpha",
    "organizationId": "org-001",
    "actorIamId": "iam-dsa-001",
    "actorName": "Maria Muster",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "ORGANIZATION_APPROVED",
    "resourceType": "Organization",
    "resourceId": "org-001",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/organizations/org-001/admission/approve",
    "requestId": "req-uuid-001",
    "clientIp": "10.0.0.1",
    "details": { "reasoning": "Alle Unterlagen vollständig und geprüft." }
  },
  {
    "id": "al-002",
    "occurredAt": "{{daysAgo:0:20}}",
    "tenantId": "tenant-beta",
    "organizationId": "org-002",
    "actorIamId": "iam-admin-002",
    "actorName": "Karl König",
    "actorRole": "ORGANIZATION_ADMIN",
    "action": "MEMBER_CREATED",
    "resourceType": "Member",
    "resourceId": "member-101",
    "outcome": "SUCCESS",
    "httpMethod": "POST",
    "httpPath": "/api/members",
    "requestId": "req-uuid-002",
    "clientIp": "10.0.0.2",
    "details": { "email": "neues.mitglied@beispiel.de" }
  },
  {
    "id": "al-003",
    "occurredAt": "{{daysAgo:1:0}}",
    "tenantId": "tenant-gamma",
    "organizationId": "org-003",
    "actorIamId": "iam-rep-003",
    "actorName": "Petra Paulsen",
    "actorRole": "ORGANIZATION_REPRESENTATIVE",
    "action": "ROLE_ASSIGNED",
    "resourceType": "Member",
    "resourceId": "member-202",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/members/member-202",
    "requestId": "req-uuid-003",
    "clientIp": "10.0.0.3",
    "details": { "assignedRole": "ORGANIZATION_ADMIN" }
  },
  {
    "id": "al-004",
    "occurredAt": "{{daysAgo:1:90}}",
    "tenantId": null,
    "organizationId": "org-001",
    "actorIamId": "iam-user-004",
    "actorName": "Tom Tester",
    "actorRole": "ORGANIZATION_USER",
    "action": "USECASE_PARTICIPATION_REQUESTED",
    "resourceType": "UseCaseParticipation",
    "resourceId": "part-301",
    "outcome": "SUCCESS",
    "httpMethod": "POST",
    "httpPath": "/api/use-cases/supply-chain/participation",
    "requestId": "req-uuid-004",
    "clientIp": "10.0.0.4",
    "details": { "useCaseId": "supply-chain" }
  },
  {
    "id": "al-005",
    "occurredAt": "{{daysAgo:2:15}}",
    "tenantId": "tenant-alpha",
    "organizationId": "org-002",
    "actorIamId": "iam-dsa-001",
    "actorName": "Maria Muster",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "USECASE_PARTICIPATION_APPROVED",
    "resourceType": "UseCaseParticipation",
    "resourceId": "part-301",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/use-cases/participation/part-301/approve",
    "requestId": "req-uuid-005",
    "clientIp": "10.0.0.1",
    "details": { "reasoning": "Teilnahmevoraussetzungen erfüllt." }
  },
  {
    "id": "al-006",
    "occurredAt": "{{daysAgo:2:60}}",
    "tenantId": "tenant-beta",
    "organizationId": "org-002",
    "actorIamId": "iam-admin-002",
    "actorName": "Karl König",
    "actorRole": "ORGANIZATION_ADMIN",
    "action": "TENANT_PROVISIONED",
    "resourceType": "Tenant",
    "resourceId": "tenant-beta",
    "outcome": "SUCCESS",
    "httpMethod": "POST",
    "httpPath": "/api/tenants",
    "requestId": "req-uuid-006",
    "clientIp": "10.0.0.2",
    "details": { "tenantName": "tenant-beta" }
  },
  {
    "id": "al-007",
    "occurredAt": "{{daysAgo:3:0}}",
    "tenantId": "tenant-gamma",
    "organizationId": "org-003",
    "actorIamId": "iam-rep-003",
    "actorName": "Petra Paulsen",
    "actorRole": "ORGANIZATION_REPRESENTATIVE",
    "action": "TENANT_PROVISIONING_FAILED",
    "resourceType": "Tenant",
    "resourceId": "tenant-failed-x",
    "outcome": "FAILURE",
    "httpMethod": "POST",
    "httpPath": "/api/tenants",
    "requestId": "req-uuid-007",
    "clientIp": "10.0.0.3",
    "details": { "error": "Kubernetes namespace conflict" }
  },
  {
    "id": "al-008",
    "occurredAt": "{{daysAgo:3:45}}",
    "tenantId": null,
    "organizationId": "org-001",
    "actorIamId": "iam-dsa-005",
    "actorName": "Sandra Stern",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "ORGANIZATION_REJECTED",
    "resourceType": "Organization",
    "resourceId": "org-003",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/organizations/org-003/admission/reject",
    "requestId": "req-uuid-008",
    "clientIp": "10.0.0.5",
    "details": { "reasoning": "Fehlende Handelsregisterdaten." }
  },
  {
    "id": "al-009",
    "occurredAt": "{{daysAgo:4:10}}",
    "tenantId": "tenant-alpha",
    "organizationId": "org-001",
    "actorIamId": "iam-admin-002",
    "actorName": "Karl König",
    "actorRole": "ORGANIZATION_ADMIN",
    "action": "MEMBER_UPDATED",
    "resourceType": "Member",
    "resourceId": "member-101",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/members/member-101",
    "requestId": "req-uuid-009",
    "clientIp": "10.0.0.2",
    "details": { "updatedFields": ["position", "phoneNumber"] }
  },
  {
    "id": "al-010",
    "occurredAt": "{{daysAgo:4:80}}",
    "tenantId": "tenant-beta",
    "organizationId": "org-002",
    "actorIamId": "iam-user-004",
    "actorName": "Tom Tester",
    "actorRole": "ORGANIZATION_USER",
    "action": "MEMBER_DEACTIVATED",
    "resourceType": "Member",
    "resourceId": "member-303",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/members/member-303",
    "requestId": "req-uuid-010",
    "clientIp": "10.0.0.4",
    "details": { "reason": "Mitarbeiter ausgeschieden" }
  },
  {
    "id": "al-011",
    "occurredAt": "{{daysAgo:5:0}}",
    "tenantId": null,
    "organizationId": "org-003",
    "actorIamId": "iam-rep-003",
    "actorName": "Petra Paulsen",
    "actorRole": "ORGANIZATION_REPRESENTATIVE",
    "action": "REP_CHANGE_REQUESTED",
    "resourceType": "RepresentativeChange",
    "resourceId": "rep-change-401",
    "outcome": "SUCCESS",
    "httpMethod": "POST",
    "httpPath": "/api/representative-change-requests",
    "requestId": "req-uuid-011",
    "clientIp": "10.0.0.3",
    "details": { "newRepresentativeId": "member-404" }
  },
  {
    "id": "al-012",
    "occurredAt": "{{daysAgo:5:30}}",
    "tenantId": null,
    "organizationId": "org-003",
    "actorIamId": "iam-dsa-001",
    "actorName": "Maria Muster",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "REP_CHANGE_APPROVED",
    "resourceType": "RepresentativeChange",
    "resourceId": "rep-change-401",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/representative-change-requests/rep-change-401/approve",
    "requestId": "req-uuid-012",
    "clientIp": "10.0.0.1",
    "details": {}
  },
  {
    "id": "al-013",
    "occurredAt": "{{daysAgo:6:20}}",
    "tenantId": "tenant-alpha",
    "organizationId": "org-001",
    "actorIamId": "iam-admin-002",
    "actorName": "Karl König",
    "actorRole": "ORGANIZATION_ADMIN",
    "action": "VC_ISSUED",
    "resourceType": "VerifiableCredential",
    "resourceId": "vc-501",
    "outcome": "SUCCESS",
    "httpMethod": "POST",
    "httpPath": "/api/credentials",
    "requestId": "req-uuid-013",
    "clientIp": "10.0.0.2",
    "details": { "credentialType": "MembershipCredential" }
  },
  {
    "id": "al-014",
    "occurredAt": "{{daysAgo:7:5}}",
    "tenantId": "tenant-alpha",
    "organizationId": "org-001",
    "actorIamId": "iam-dsa-001",
    "actorName": "Maria Muster",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "VC_REVOKED",
    "resourceType": "VerifiableCredential",
    "resourceId": "vc-502",
    "outcome": "SUCCESS",
    "httpMethod": "DELETE",
    "httpPath": "/api/credentials/vc-502",
    "requestId": "req-uuid-014",
    "clientIp": "10.0.0.1",
    "details": { "reason": "Organisation gesperrt" }
  },
  {
    "id": "al-015",
    "occurredAt": "{{daysAgo:7:120}}",
    "tenantId": null,
    "organizationId": null,
    "actorIamId": "iam-dsa-005",
    "actorName": "Sandra Stern",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "AUDIT_LOG_EXPORTED",
    "resourceType": "AuditLog",
    "resourceId": null,
    "outcome": "SUCCESS",
    "httpMethod": "GET",
    "httpPath": "/api/audit-logs/export",
    "requestId": "req-uuid-015",
    "clientIp": "10.0.0.5",
    "details": { "format": "CSV", "entries": 240 }
  },
  {
    "id": "al-016",
    "occurredAt": "{{daysAgo:8:0}}",
    "tenantId": "tenant-gamma",
    "organizationId": "org-003",
    "actorIamId": "iam-user-004",
    "actorName": "Tom Tester",
    "actorRole": "ORGANIZATION_USER",
    "action": "COMMENT_ADDED",
    "resourceType": "Organization",
    "resourceId": "org-003",
    "outcome": "SUCCESS",
    "httpMethod": "POST",
    "httpPath": "/api/organizations/org-003/admission/comments",
    "requestId": "req-uuid-016",
    "clientIp": "10.0.0.4",
    "details": { "commentId": "c-601" }
  },
  {
    "id": "al-017",
    "occurredAt": "{{daysAgo:9:30}}",
    "tenantId": "tenant-beta",
    "organizationId": "org-002",
    "actorIamId": "iam-rep-003",
    "actorName": "Petra Paulsen",
    "actorRole": "ORGANIZATION_REPRESENTATIVE",
    "action": "ROLE_REVOKED",
    "resourceType": "Member",
    "resourceId": "member-202",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/members/member-202",
    "requestId": "req-uuid-017",
    "clientIp": "10.0.0.3",
    "details": { "revokedRole": "ORGANIZATION_ADMIN" }
  },
  {
    "id": "al-018",
    "occurredAt": "{{daysAgo:10:0}}",
    "tenantId": "tenant-alpha",
    "organizationId": "org-001",
    "actorIamId": "iam-admin-002",
    "actorName": "Karl König",
    "actorRole": "ORGANIZATION_ADMIN",
    "action": "USECASE_PARTICIPATION_REJECTED",
    "resourceType": "UseCaseParticipation",
    "resourceId": "part-302",
    "outcome": "SUCCESS",
    "httpMethod": "PUT",
    "httpPath": "/api/use-cases/participation/part-302/reject",
    "requestId": "req-uuid-018",
    "clientIp": "10.0.0.2",
    "details": { "reasoning": "Connector nicht eingerichtet." }
  },
  {
    "id": "al-019",
    "occurredAt": "{{daysAgo:12:45}}",
    "tenantId": null,
    "organizationId": "org-003",
    "actorIamId": "iam-dsa-001",
    "actorName": "Maria Muster",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "REP_CHANGE_REJECTED",
    "resourceType": "RepresentativeChange",
    "resourceId": "rep-change-402",
    "outcome": "FAILURE",
    "httpMethod": "PUT",
    "httpPath": "/api/representative-change-requests/rep-change-402/reject",
    "requestId": "req-uuid-019",
    "clientIp": "10.0.0.1",
    "details": { "reason": "Nachweis unvollständig." }
  },
  {
    "id": "al-020",
    "occurredAt": "{{daysAgo:14:10}}",
    "tenantId": "tenant-gamma",
    "organizationId": "org-003",
    "actorIamId": "iam-dsa-005",
    "actorName": "Sandra Stern",
    "actorRole": "DATASPACE_AUTHORITY",
    "action": "MEMBER_CREATED",
    "resourceType": "Member",
    "resourceId": "member-505",
    "outcome": "FAILURE",
    "httpMethod": "POST",
    "httpPath": "/api/members",
    "requestId": "req-uuid-020",
    "clientIp": "10.0.0.5",
    "details": { "error": "E-Mail bereits vergeben." }
  }
]
